/**
 * Shared admin list/table shell classes — live tables and skeletons use the same box.
 */

export const adminListTableShellClass =
  'overflow-x-auto overflow-y-visible rounded-2xl border border-primary-500/10 bg-white shadow-sm';

export const adminListTableSkeletonHeaderClass =
  'space-y-0 border-b border-gray-200 bg-slate-50 px-4 py-3';

export const adminListTableSkeletonRowClass =
  'flex gap-4 border-b border-gray-100 px-4 py-3 last:border-b-0 even:bg-gray-50/50';

export const adminFilterToolbarClass =
  'flex min-w-0 flex-wrap items-center gap-2';

export const adminFilterControlClass = 'h-9 min-h-[44px] sm:min-h-0 sm:h-9';
